import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Map } from "immutable";
import {
    Form,
    // Icon,
    List,
    message,
    Modal,
} from "antd";
import { connect } from "react-redux";
import { fieldGenerator, getErrorOnField, submitForm } from "utilities/form";
import { AddressRecord, AssociateRecord } from "records/company-record";
import { APPLICANT_FIELDS_ASSOCIATE } from "constants/form-fields";
// import moment from "moment";
import "styles/form.css";
import moment from "moment";
import DocumentViewer from "components/document-viewer";
import { bindActionCreators } from "redux";
import { fetchPanAadharLink } from "../store/actions";

const ListItem = List.Item;

class AddAssociateForm extends React.Component {
    state = {
        showDocumentViewer: false,
        documentUrl: null,
    };

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(
        this.props.form,
        ({ name, residence_address, permanent_address, ...restValues }) =>
            this.props.onFormSubmit(
                new AssociateRecord({ ...name, ...restValues }),
                new AddressRecord({
                    ...residence_address,
                    ...permanent_address,
                    associate: restValues.associate
                })
            )
    );

    sameAddressCallback = (checked) =>{
        console.log("checked",checked);
    }
    onChangeValues = () => {
        // this.props.onValuesChange(
        //     new AssociateRecord({ ...name, ...restValues }),
        //     new AddressRecord({
        //         ...residence_address,
        //         associate: restValues.associate
        //     })
        // );
    };
    handleViewDocument = () => {
        const aadharPanLink = this.props.form.getFieldValue("aadhar_pan_link_document");
        if (aadharPanLink) {
            this.setState({
                showDocumentViewer: true,
                documentUrl: aadharPanLink,
            });
        } else {
            message.error("Aadhar PAN link document not available.");
        }
    };

    handleCloseDocumentViewer = () => {
        this.setState({
            showDocumentViewer: false,
            documentUrl: null,
        });
    };
    
    getFormField(fieldName, field) {
        // if((this.props.associateCreatedFlag && fieldName ==="permanent_address" || this.props.associateCreatedFlag && fieldName ==="residence_address") && (this.props.associateID === this.props.associateKeys[this.props.associateKeys.length-1])){
        //     field.disabled = true;
        // }else{
        //     field.disabled = false;
        // }
        // if((this.props.associateCreatedFlag && fieldName ==="phone" || this.props.associateCreatedFlag && fieldName ==="email") && (this.props.associateID !== this.props.associateKeys[this.props.associateKeys.length-1])){
        //     field.disabled = true;
        // }
        if( fieldName === "name_pdeed"){
            const companyType = this.props.company.constitution;
            if(companyType === 2 || companyType === 6){
                field.rules = [
                    {
                        required: true,
                        message: "Name as on Partnership Deed is Required"
                    }];
            }else{
                field.rules = [
                    {
                        required: false,
                    }];
            }
        }
        if( fieldName === "shareholding"){
        //     if(companyType === 1 || (companyType !== 1 && this.props.form.getFieldValue("shareholding") > 0)){
        //         field.rules = [
        //             {
        //                 required: false,
        //             }];
        //     }else if(companyType !== 1 && this.props.form.getFieldValue("shareholding") <= 0){
        //         field.rules = [
        //             {
        //                 required: true,
        //                 message: "Shareholding is required"
        //             },
        //             {
        //                 pattern: /^\d*[1-9]\d*$/,
        //                 message: "Shareholding cannot be <= 0"
        //             }
        //         ];
        //     }
        }
        if (this.props.editable) {
            // if((fieldName ==="phone" || fieldName ==="email") && (this.props.associateID !== this.props.associateKeys[this.props.associateKeys.length-1])) {
            //     field.disabled = true;
            // }
            if (fieldName === "type") {
                if(this.props.values.get("id")) {
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getErrorOnField(fieldName)
                    )();
                }
                return (
                    <div
                        className={
                            "w-100 d-flex justify-content-space-between align-items-center"
                        }
                    >
                        <div>
                            {
                                (
                                    field.options.find(
                                        _ =>
                                            _.value ===
                                            this.props.values.get(fieldName)
                                    ) || {}
                                ).label
                            }
                        </div>
                    </div>
                );
            }
            if(fieldName === "remove") {
                field.icon = "close";
                field.onClick = !this.props.values.get("id") ? this.props.deleteAssociate : this.props.deleteAssociateFromList;
            }
            if(fieldName === "aadhar_pan_link_document") {
                field.onClick = this.handleViewDocument;
            }
            if(fieldName === "refresh_pan_aadhar_link") {
                field.onClick = () => this.props.fetchPanAadharLink(this.props.caseId, this.props.associateID);
;
            }
            if (
                this.props.values.get("type") === 2 &&
                fieldName === "is_main_borrower"
            ) {
                return this.fieldGenerator(
                    fieldName,
                    { ...field, disabled: true },
                    this.getErrorOnField(fieldName)
                )();
            }
            if(fieldName === "spouse_name") {
                let marital_status = this.props.form.getFieldValue("marital_status");
                let gender = this.props.form.getFieldValue("gender");
                if(marital_status ===  2 && gender === 2) {
                    field.disabled = false;
                    // field.rules = [
                    //     {
                    //         required: true,
                    //         message: "Spouse name is required"        
                    //     }
                    // ];
                } else {
                    field.disabled = true;
                    field.rules = [];
                }
            }
            if(fieldName === "father_name") {
                let marital_status = this.props.form.getFieldValue("marital_status");
                let gender = this.props.form.getFieldValue("gender");
                if (marital_status !==  2 || gender !== 2) {
                    field.disabled = false;
                    field.rules = [
                        {
                            required: true,
                            message: "Father's name is required"        
                        }
                    ];
                }else if(marital_status ===  2 || gender === 2){
                    field.rules = [];
                    field.disabled = false;
                } 
                else {
                    field.disabled = true;
                    field.rules = [];
                }
            }
            return this.fieldGenerator(
                fieldName,
                {...field, 
                    inputformprops : {
                        sameAddressCallback: this.props.sameAddressEventListener,
                        checkBoxTableID: this.props.associateID,
                        ...field.inputformprops
                    }
                },
                this.getErrorOnField(fieldName)
            )();
        }

        if(fieldName === "shareholding") {
            return this.props.values.get(fieldName) + " %";
        }
        return this.props.values.get(fieldName);
    }

    // setShareholding = val => {
    //     if (val === 1) {
    //         this.props.form.setFieldsValue({ shareholding: 100 });
    //     }
    // };
    render() {
        let APPLICANT_FIELDS_UPDATED = APPLICANT_FIELDS_ASSOCIATE;
        if(this.props.recreditViewOnlyPermission === true){
            APPLICANT_FIELDS_UPDATED = APPLICANT_FIELDS_ASSOCIATE?.filter((field,fieldName) => {
                return fieldName !== "remove";
            });
        }
        const keySource = this.props.values.key_source || {};
        return (
            <React.Fragment>
                <Form
                    layout="vertical"
                    hideRequiredMark={false}
                    className={cx("form-vertical", "f-grow-1", "br-3")}
                    // onValuesChange={this.onChangeValues}
                    onSubmit={this.handleFormSubmit}>
                    <List bordered className={"tabled-list"}>
                        {APPLICANT_FIELDS_UPDATED?.map((field, fieldName) => {
                            return (
                                <ListItem
                                    className={`form-field-list-item ${keySource && Object.keys(keySource).length ? keySource[fieldName] + '_color': ""}`}
                                    key={fieldName}>
                                    {this.getFormField(fieldName, field)}
                                </ListItem>
                            );
                        }).toList()}
                    </List>
                </Form>
                <Modal
                    visible={this.state.showDocumentViewer}
                    footer={null}
                    title="Aadhar Pan Link"
                    width={"80%"}
                    style={{ top: 10 }} 
                    bodyStyle={{ height: "85vh", padding: 0 }} 
                    onCancel={() => this.handleCloseDocumentViewer()}
                >
                    <iframe
                        src={this.state.documentUrl}
                        title="PDF viewer"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />        </Modal>

            </React.Fragment>
        );
    }
}

AddAssociateForm.propTypes = {
    values: PropTypes.object,
    form: PropTypes.object,
    company: PropTypes.object,
    onFormSubmit: PropTypes.func,
    deleteAssociate: PropTypes.func,
    onValuesChange: PropTypes.func,
    editable: PropTypes.bool,
    showSpocOnly: PropTypes.bool,
    deleteAssociateFromList: PropTypes.func,
    sameAddressEventListener: PropTypes.func,
    associateID: PropTypes.number,
    associateCreatedFlag: PropTypes.bool,
    associateKeys: PropTypes.array,
    recreditViewOnlyPermission: PropTypes.bool,
    fetchPanAadharLink: PropTypes.func,
    caseId: PropTypes.number
};

const mapStateToProps = (state, props) => ({
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        fetchPanAadharLink
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
  { forwardRef: true }
)(Form.create({
    mapPropsToFields: ({ values, editable }) =>
        editable &&
        values &&
        Object.keys(values).length &&
        new Map(values)
            .map((value, key) => {
                    if (key === "dob" || key === 'dob_pan' || key == 'dob_aadhar') {
                        return Form.createFormField({
                            value: value ?  moment(value) : null
                        });
                    }else if(key === 'modified_date' || key === 'create_date' ){
                        return Form.createFormField({
                            value: value || ''
                        });
                    }
                return Form.createFormField({
                    value
                });
            })
            .toJS(),
    onValuesChange: ({ onValuesChange }, changedValues) =>
        onValuesChange(changedValues)
})(AddAssociateForm));
